import { createSelector } from 'reselect';

export const getNavigation = (state) => state.navigation;

export const getActionName = (entityName) =>
  createSelector([getNavigation], (navigation) => {
    return navigation.reduce((acc, item) => {
      if (item.contentInfos && item.contentInfos.menu && item.contentInfos.menu.contentData) {
        const contentData = item.contentInfos.menu.contentData;
        Array.isArray(contentData.templateData) &&
          contentData.templateData.map((data) => {
            if (data.Links) {
              data.Links.map((link) => {
                if (link.EntityName === entityName) {
                  acc = link.ActionName;
                }
              });
            }
          });
      }
      return acc;
    }, null);
  });
